import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { WarehouseProductType } from '../../enums/warehouse-product-type';
import { WarehouseProductOwnerResponse } from './warehouse-product-owner.response';
import { WarehouseProductLocalizationResponse } from './warehouse-product-localization.response';
import { QuantityUnit } from '@web/shared/module/measurement';
import { WarehouseProductBrandResponse } from './warehouse-product-brand.response';
import { WarehouseProductContextOperationsResponse } from './warehouse-product-context-operations.response';

@jsonObject
export class WarehouseProductDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly type!: WarehouseProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(String)
  public readonly quantityUnit!: QuantityUnit;

  @jsonMember(String)
  public readonly sku!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(WarehouseProductOwnerResponse)
  public readonly owner!: WarehouseProductOwnerResponse;

  @jsonMember(WarehouseProductBrandResponse)
  public readonly brand!: WarehouseProductBrandResponse;

  @jsonMember(WarehouseProductLocalizationResponse)
  public readonly localisation?: Nillable<WarehouseProductLocalizationResponse>;

  @jsonMember(Boolean)
  public readonly promotion!: boolean;

  @jsonMember(String)
  public readonly durabilityInformation!: string;

  @jsonMember(String)
  public readonly measure!: string;

  @jsonMember(WarehouseProductContextOperationsResponse)
  public readonly contextOperations!: WarehouseProductContextOperationsResponse;
}
